import React from 'react';

import startCase from 'lodash/startCase';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { RenewalOrderStatus } from '@appTypes/enums';
import { programSel } from '@context/duck/selectorsTyped';
import {
  peopleFilters,
  programGrownUpAges,
  registrationSituationStatuses,
  renewalStatuses,
} from '@modules/advancement/packRoster/constants';
import { featureFlags } from '@modules/featureFlags/utils/featureFlags';
import { Program } from '@shared';
import { Checkbox, ConditionalRender, S } from '@shared/components';
import { intl } from '@shared/localization';

import styles from '../PackRosterFilterCard.less';

interface Props {
  values: Record<string, boolean>;
  onChange: (filter: Record<string, boolean>) => void;
}
const FilterSection: React.FC<Props> = ({ values, onChange }) => {
  const program = useSelector(programSel);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target;
    const newValues = {
      ...values,
      [name]: !values[name],
    };

    onChange(newValues);
  };

  const renderCheckbox = (name: string, label: string) => (
    <Checkbox
      key={name}
      name={name}
      checked={values[name]}
      onChange={handleChange}
    >
      <S size="4" colored inline>
        {label}
      </S>
    </Checkbox>
  );

  return (
    <div className={styles.rosterFiltersContainer}>
      {/* Type Filters */}
      <div>
        <S size="3" colored>
          <FormattedMessage id="packRoster.PackRosterFilterCard.type" />
        </S>
        {renderCheckbox(
          peopleFilters.YOUTH,
          intl.formatMessage({
            id: 'advancement.PackRoster.showYouth',
          }),
        )}
        {program !== Program.CUB_SCOUT &&
          renderCheckbox(
            peopleFilters.AGED_YOUTH,
            intl.formatMessage(
              {
                id: 'advancement.PackRoster.showAgedYouth',
              },
              {
                age: programGrownUpAges[program],
              },
            ),
          )}
        {renderCheckbox(
          peopleFilters.ADULTS,
          intl.formatMessage({
            id: 'advancement.PackRoster.showAdults',
          }),
        )}
        {program === Program.CUB_SCOUT &&
          renderCheckbox(
            peopleFilters.DEN_CHIEFS,

            intl.formatMessage({
              id: 'advancement.PackRoster.showDenChiefs',
            }),
          )}
      </div>

      {/* Renewal Status Filters */}
      <div key="renewalStatus">
        <S size="3" colored>
          <FormattedMessage id="packRoster.PackRosterFilterCard.renewalStatus" />
        </S>
        {Object.values(renewalStatuses).map(status =>
          renderCheckbox(status, status),
        )}
      </div>

      {/* Registration Status Filters */}
      <div>
        <S size="3" colored>
          <FormattedMessage id="packRoster.PackRosterFilterCard.registrationStatus" />
        </S>
        {Object.values(registrationSituationStatuses).map(status =>
          renderCheckbox(
            status,
            intl.formatMessage({
              id: `packRoster.PackRosterFilterCard.${status}`,
            }),
          ),
        )}
      </div>
      {/* Order Status */}
      <ConditionalRender
        value={featureFlags.getFlag('SBL_5483_GROUPBY_ORDER_STATUS')}
      >
        <div key="orderStatus">
          <S size="3" colored>
            <FormattedMessage id="packRoster.PackRosterFilterCard.orderStatus" />
          </S>
          {Object.entries(RenewalOrderStatus).map(([key, label]) =>
            renderCheckbox(`order_status_${key}`, startCase(label)),
          )}
        </div>
      </ConditionalRender>
    </div>
  );
};

export default FilterSection;
